/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from 'antd';
import { useEffect } from 'react';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { TextAreaProps } from './FormTextArea.component';

const CommonTextArea = ({
    style,
    maxLength,
    name,
    placeholder = PLACEHOLDER.TEXT,
    onChange,
    resize = false,
    currentForm,
    rules = [],
    onValidateError,
    ...props
}: TextAreaProps) => {
    useEffect(() => {
        if (currentForm && onValidateError) {
            currentForm
                .validateFields([name || ''], {
                    validateOnly: currentForm.getFieldError(name || '').length <= 0,
                })
                .then(() => {
                    onValidateError(false);
                })
                .catch(() => {
                    onValidateError(true);
                });
        }
    }, [rules]);

    return (
        <Input.TextArea
            {...props}
            maxLength={maxLength}
            style={style ?? { resize: resize ? 'vertical' : 'none' }}
            placeholder={placeholder}
            onChange={(e) => {
                onChange && onChange(e.target.value);
            }}
        />
    );
};

export default CommonTextArea;
